import { HTMLEditor } from "./HTMLEditor";

export interface Query
{
  get selector():string;
  query( element:Element ):Element
  queryAll( element:Element):Element[]    
}

export abstract class AbstractQuery implements Query
{
  abstract get selector():string;

  query( element:Element ):Element
  {
    return element.querySelector( this.selector );
  }

  queryAll( element:Element ):Element[]
  {
    return HTMLEditor.nodeListToArray( element.querySelectorAll( this.selector ) );
  } 
}
